import { render, staticRenderFns } from "./FullTips.vue?vue&type=template&id=2f7a2df2&scoped=true"
import script from "./FullTips.vue?vue&type=script&lang=js"
export * from "./FullTips.vue?vue&type=script&lang=js"
import style0 from "./FullTips.vue?vue&type=style&index=0&id=2f7a2df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a2df2",
  null
  
)

export default component.exports